import { createSelector } from 'reselect';
import { IFormConfigState } from '../reducers/formConfigReducer';
import { RootStore } from '../reducers';

const formConfigSelector = createSelector(
  (state: RootStore) => state.formConfig,
  (formConfigState: IFormConfigState) => formConfigState,
);

export const currentStepSelector = createSelector(
  formConfigSelector,
  (formConfigState: IFormConfigState) => formConfigState.currentStep,
);

export const registerDataSelector = createSelector(
  formConfigSelector,
  (formConfigState: IFormConfigState) => formConfigState.registerData,
);

export const telephoneNumberFormatSelector = createSelector(
  formConfigSelector,
  (formConfigState: IFormConfigState) => formConfigState.telephoneNumberFormat,
);

export const isRedirectFromSummarySelector = createSelector(
  formConfigSelector,
  (formConfigState: IFormConfigState) => formConfigState.isRedirectFromSummary,
);

export const disableSubmitSelector = createSelector(
  formConfigSelector,
  (formConfigState: IFormConfigState) => formConfigState.disableSubmit,
);

export const acceptedStepsSelector = createSelector(
  formConfigSelector,
  (formConfigState: IFormConfigState) => formConfigState.acceptedSteps,
);

export const stepsSelector = createSelector(
  formConfigSelector,
  (formConfigState: IFormConfigState) => formConfigState.steps,
);

export const customFieldsSelector = createSelector(
  formConfigSelector,
  (formConfigState: IFormConfigState) => formConfigState.customFields,
);

export const countrySelector = createSelector(
  formConfigSelector,
  (formConfigState: IFormConfigState) => formConfigState.selectedCountry,
);

export const validationResponseSelector = createSelector(
  formConfigSelector,
  (formConfigState: IFormConfigState) => formConfigState.validationResponse,
);
